module.exports = __webpack_public_path__ + "static/media/logo.270588fe.png";